import { getSettingsInLaguage } from './get-settings'

import base from './base/base-en.json'

// Forms
import complaintForm from './form-complaint/form-complaint-en.json'
import testivalForm from './form-testival/form-testival-en.json'
import form from './form/form-en.json'

// Other
import account from './account/account-en.json'
import checkout from './checkout/checkout-en.json'
import customer from './customer/customer-en.json'
import help from './help/help-en.json'
import specs from './specs/specs-en.json'
import usermanagement from './usermanagement/usermanagement-en.json'
import ticketView from './ticket-view/ticket-view-en.json'
import launchportal from './launchportal/launchportal-en.json'
import vuetify from './vuetify/vuetify-en.json'
import pageTitles from './page-titles/page-titles-en.json'
import bidex from './bidex/bidex-en.json'
import filter from './filter/filter-en.json'
import messages from './messages/messages-en.json'
import contractCheck from './contract-check/contract-check-en.json'
import dealerbook from './dealerbook/dealerbook-en.json'
import hubspot from './hubspot/hubspot-en.json'

const en = {
  settings: getSettingsInLaguage('en'),
  pageTitles,
  bidex,
  filter,
  account,
  checkout,
  customer,
  complaintForm,
  testivalForm,
  form,
  help,
  specs,
  messages,
  usermanagement,
  dealerbook,
  hubspot,
  'contract-check': contractCheck,
  'ticket-view': ticketView,
  launchportal,
  $vuetify: vuetify,
  ...base,
}

export default en
